import { useState, useEffect } from "react";
import axios from "axios";
import qs from "qs";
// import { Fade } from "react-awesome-reveal";

import "../../../utilities.css"
import "./Governance.css";

import TopBanner from "../../modules/TopBanner.js";
import ContentBlock from "../../modules/ContentBlock.js";
import AllComms from "../../modules/AllComms.js";
import PrevComms from "../../modules/PrevComms.js";
import ButtonFlex from "../../modules/ButtonFlex.js";

const Governance = ({ todayYear }) => {
  const startCommitteeYear = 2010;
  const prevCommYearArr = [...Array(todayYear - startCommitteeYear).keys()].map(i=>todayYear-i-1);

  const [currentComm, setCurrentComm] = useState([]);
  const [documents, setDocuments] = useState({});
  const [prevCommStartYear, setPrevCommStartYear] = useState(todayYear-1);
  const [prevCommArr, setPrevCommArr] = useState([]);

  const getCurrentComm = async () => {
    const query = qs.stringify({
      fields: ['startYear', 'endYear', 'notes'],
      filters: { 
        startYear: { $lte: todayYear },
        endYear: { $gte: todayYear + 1 },
      },
      populate: {
        profile: { 
          fields: ['username', 'preferredName', 'display'],
          populate: {
            profilePicture: {fields: ['url', 'alternativeText']},
          },
        },
        committee_post: { fields: ['name', 'rank'] },
      },
      sort: ['committee_post:rank'],
      pagination: { limit: 20 }
    })

    await axios.get(`/strapi/api/committee-engagements?${query}`
      ).then((res) => {setCurrentComm(res.data.data);}).catch(e => {console.log(e)});
  };

  const getDocuments = async () => {
    const query = qs.stringify({
      fields: ['constitution', 'constitutionPDF'],
      populate: {
        committeePicture: {
          fields: ['formats', 'url']
        }
      }
    })

    await axios.get(`/strapi/api/general-document?${query}`
      ).then((res) => {setDocuments(res.data.data)}
      ).catch(e => {console.log(e)});
  }

  useEffect(() => {getCurrentComm(); getDocuments();}, []);

  const getPrevCommArr = async () => {
    const query = qs.stringify({
      filters: { 
        startYear: { $lte: prevCommStartYear },
        endYear: { $gte: prevCommStartYear + 1 },
      },
      populate: {
        profile: { fields: ['username', 'preferredName', 'display'] },
        committee_post: { fields: ['name', 'rank'] },
      },
      sort: ['committee_post:rank'],
      pagination: { limit: 20 }
    })

    await axios.get(`/strapi/api/committee-engagements?${query}`
      ).then((res) => {setPrevCommArr(res.data.data);}).catch(e => {console.log(e)});
  };

  useEffect(() => {getPrevCommArr();}, [prevCommStartYear]);

  let committeePic = "";

  if (documents.committeePicture) {
    committeePic = documents.committeePicture.formats.large.url;
  }

  return (<>
    <TopBanner backgroundImage={committeePic} title="About" content="Governance" />

    {/* <Fade cascade={true} direction="up" triggerOnce> */}
    <ContentBlock title="Governance">
      <p>The WCR is governed by a committee of graduate students who advocate for and 
        represent the interests of the graduate student body within the College, University 
        and the Oxford SU. The committee also runs exciting social events (including BOPs) 
        and provides supports to the College postgraduate community.
      </p>
      <p>
        The WCR committee binds with the constitution, and is elected at the end of 
        the Hilary (second) Term each year.
      </p>
      <ButtonFlex display={[
          {key: 1, isLocal: false, des: "Constitution (HTML)", link: documents.constitution},
          {key: 2, isLocal: false, des: "Constitution (Official PDF)", link: documents.constitutionPDF},
        ]}/>
    </ContentBlock>
    <ContentBlock title="Current Committee Members">
      <AllComms commArr={currentComm} />
    </ContentBlock>

    <ContentBlock title="Past Committee Members">
      <p>We thank the previous committee members in contributing to the success of our common room. 
        Below is a list of our alumni who had served in the WCR Committee, drawn from previous meeting minutes, and even 
        the <a href="https://web.archive.org/web/20260000000000*/https://univwcr.wordpress.com/">previous versions</a> of our website. 
        If you have noticed any inaccuracies of this record, or wish to have your name added/removed, please <a href="mailto:wcr.secretary@univ.ox.ac.uk">contact our secretary</a>.</p>
      <ul className="prevComm-year-container">
        {prevCommYearArr.map((item) => 
          <li className="prevComm-year-item" key={item}>
            <button
              onClick={() => setPrevCommStartYear(item)}
              className={prevCommStartYear === item ? "prevComm-year-outline" : "prevComm-year-default"}>
                {`${item}-${item+1}`}
            </button>
          </li>
        )}
      </ul>

      <select
        value={prevCommStartYear}
        onChange={(e) => setPrevCommStartYear(Number(e.target.value))}
        className="prevComm-year-dropdown">
        {prevCommYearArr.map((item) => <option key={item} value={item}>{item}-{item+1}</option>)}
      </select>

      <PrevComms prevComm={prevCommArr} prevCommStartYear={prevCommStartYear} />

    </ContentBlock>
    {/* </Fade> */}
    </>
  );
}

export default Governance;